import Alpine from 'alpinejs';

export default class ApplicationForm {
  constructor(_applicationForm) {
    window.Alpine = Alpine;
    Alpine.start();
  }
}
